export const WASABI_SEARCH_USERS_START = 'WASABI_SEARCH_USERS_START';
export const WASABI_SEARCH_USERS_SUCCESS = 'WASABI_SEARCH_USERS_SUCCESS';
export const WASABI_SEARCH_USERS_FAILURE = 'WASABI_SEARCH_USERS_FAILURE';

export const WASABI_FETCH_USER_START = 'WASABI_FETCH_USER_START';
export const WASABI_FETCH_USER_SUCCESS = 'WASABI_FETCH_USER_SUCCESS';
export const WASABI_FETCH_USER_FAILURE = 'WASABI_FETCH_USER_FAILURE';

export const WASABI_FETCH_USER_SUBSCRIPTIONS_START =
  'WASABI_FETCH_USER_SUBSCRIPTIONS_START';
export const WASABI_FETCH_USER_SUBSCRIPTIONS_SUCCESS =
  'WASABI_FETCH_USER_SUBSCRIPTIONS_SUCCESS';
export const WASABI_FETCH_USER_SUBSCRIPTIONS_FAILURE =
  'WASABI_FETCH_USER_SUBSCRIPTIONS_FAILURE';

export const WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_START =
  'WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_START';
export const WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_SUCCESS =
  'WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_SUCCESS';
export const WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_FAILURE =
  'WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_FAILURE';

export const WASABI_FETCH_USER_COURSES_START =
  'WASABI_FETCH_USER_COURSES_START';
export const WASABI_FETCH_USER_COURSES_SUCCESS =
  'WASABI_FETCH_USER_COURSES_SUCCESS';
export const WASABI_FETCH_USER_COURSES_FAILURE =
  'WASABI_FETCH_USER_COURSES_FAILURE';

export const WASABI_FETCH_USER_INSTITUTIONS_START =
  'WASABI_FETCH_USER_INSTITUTIONS_START';
export const WASABI_FETCH_USER_INSTITUTIONS_SUCCESS =
  'WASABI_FETCH_USER_INSTITUTIONS_SUCCESS';
export const WASABI_FETCH_USER_INSTITUTIONS_FAILURE =
  'WASABI_FETCH_USER_INSTITUTIONS_FAILURE';

export const WASABI_FETCH_EMAIL_TEMPLATES_LIST_START =
  'WASABI_FETCH_EMAIL_TEMPLATES_LIST_START';
export const WASABI_FETCH_EMAIL_TEMPLATES_LIST_SUCCESS =
  'WASABI_FETCH_EMAIL_TEMPLATES_LIST_SUCCESS';
export const WASABI_FETCH_EMAIL_TEMPLATES_LIST_FAILURE =
  'WASABI_FETCH_EMAIL_TEMPLATES_LIST_FAILURE';

export const WASABI_UPDATE_EMAIL_TEMPLATE_SELECT_TEMPLATE =
  'WASABI_UPDATE_EMAIL_TEMPLATE_SELECT_TEMPLATE';

export const WASABI_UPDATE_EMAIL_TEMPLATE_SELECT_TYPE =
  'WASABI_UPDATE_EMAIL_TEMPLATE_SELECT_TYPE';

export const WASABI_FETCH_EMAIL_TEMPLATE_RENDER_START =
  'WASABI_FETCH_EMAIL_TEMPLATE_RENDER_START';
export const WASABI_FETCH_EMAIL_TEMPLATE_RENDER_SUCCESS =
  'WASABI_FETCH_EMAIL_TEMPLATE_RENDER_SUCCESS';
export const WASABI_FETCH_EMAIL_TEMPLATE_RENDER_FAILURE =
  'WASABI_FETCH_EMAIL_TEMPLATE_RENDER_FAILURE';

export const WASABI_SEARCH_INSTITUTIONS_START =
  'WASABI_SEARCH_INSTITUTIONS_START';
export const WASABI_SEARCH_INSTITUTIONS_SUCCESS =
  'WASABI_SEARCH_INSTITUTIONS_SUCCESS';
export const WASABI_SEARCH_INSTITUTIONS_FAILURE =
  'WASABI_SEARCH_INSTITUTIONS_FAILURE';

export const WASABI_FETCH_INSTITUTION_START = 'WASABI_FETCH_INSTITUTION_START';
export const WASABI_FETCH_INSTITUTION_SUCCESS =
  'WASABI_FETCH_INSTITUTION_SUCCESS';
export const WASABI_FETCH_INSTITUTION_FAILURE =
  'WASABI_FETCH_INSTITUTION_FAILURE';

export const WASABI_FETCH_INSTITUTION_COURSES_START =
  'WASABI_FETCH_INSTITUTION_COURSES_START';
export const WASABI_FETCH_INSTITUTION_COURSES_SUCCESS =
  'WASABI_FETCH_INSTITUTION_COURSES_SUCCESS';
export const WASABI_FETCH_INSTITUTION_COURSES_FAILURE =
  'WASABI_FETCH_INSTITUTION_COURSES_FAILURE';

export const WASABI_FETCH_INSTITUTION_USAGE_START =
  'WASABI_FETCH_INSTITUTION_USAGE_START';
export const WASABI_FETCH_INSTITUTION_USAGE_SUCCESS =
  'WASABI_FETCH_INSTITUTION_USAGE_SUCCESS';
export const WASABI_FETCH_INSTITUTION_USAGE_FAILURE =
  'WASABI_FETCH_INSTITUTION_USAGE_FAILURE';

export const WASABI_FETCH_INSTITUTION_MEMBERS_START =
  'WASABI_FETCH_INSTITUTION_MEMBERS_START';
export const WASABI_FETCH_INSTITUTION_MEMBERS_SUCCESS =
  'WASABI_FETCH_INSTITUTION_MEMBERS_SUCCESS';
export const WASABI_FETCH_INSTITUTION_MEMBERS_FAILURE =
  'WASABI_FETCH_INSTITUTION_MEMBERS_FAILURE';
